import Swal from "sweetalert2";
import {UYAP_ENGEL_METINLERI as M} from "@/utils/uyapEngeli";

/**
 * Başlat onayı (K5/K8): UYAP engeli kilidi sürerken kullanıcı Başlat'a basınca sorulur. `true` = "Dene".
 * `title`/`text` düz metindir (Swal `text` HTML ayrıştırmaz). Metinlerin tek kaynağı utils/uyapEngeli.ts.
 */
export async function uyapEngeliBaslatOnayi(): Promise<boolean> {
    const sonuc = await Swal.fire({
        title: M.onayBaslik,
        text: M.onayMetin,
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        confirmButtonText: M.onayDene,
        cancelButtonText: M.onayVazgec
    });
    return sonuc.isConfirmed === true;
}
